<template>
  <div class="px-8">
    <div class="relative my-6">
      <div
        class="w-full rounded-xl z-10 flex header"
        :class="$props.isExpanded ? 'is-expanded' : 'not-expanded'"
      >
        <div
          class="flex-grow text-center"
          :class="{ 'flex justify-between items-center': !$props.isExpanded }"
        >
          <div>
            <img
              src="@/assets/images/oral-B.png"
              alt="oral b"
              class="w-40"
              :class="{ 'mx-auto': $props.isExpanded }"
            />
          </div>
        </div>
        <div v-if="$props.isExpanded">
          <img src="../assets/images/brush.png" alt="OralB Brush" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    isExpanded: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
<style lang="postcss" scoped>
.header {
  background-color: rgb(85, 163, 153, 46%);
  align-items: center;
  flex-direction: column;
  height: 213px;
  padding: 1.25rem;
  backdrop-filter: blur(5px);
  img {
    max-width: 100%;
  }
  &.is-expanded {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    overflow: hidden;
    align-items: flex-start;
  }
  &.not-expanded {
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    padding: 10px 20px;
    transition: 0.35s;
    height: 83px;
    img {
      max-width: 111px;
    }
  }
}
</style>
